import React from 'react';
import './BoxLivescoring.css';
import { getLongNameChamp } from '../variables';
import { useNavigate } from 'react-router-dom';
import VideoButton from './VideoButton';

// video : { status, videoId, url, title } (cf. findMatchVideo) ou null
function BoxLivescoring({match, championnat, video = null}) {
    const navigate = useNavigate();

    // Divisions réelles vers lesquelles on peut rediriger
    const championnatsValides = ['proam', 'proad', 'probm', 'probd'];

    // Redirection vers le match
    const handleClick = (e) => {
        e.preventDefault();
        // pas de redirection si le championnat n'est pas une vraie division
        // (ex : rencontre de test "PREPROD" du livescore, ou tag inconnu)
        if (!championnatsValides.includes(championnat)) {
            return;
        }
        // if (match.status == "en_cours") {
            navigate(`${championnat}/calendrier`, { state: {
                goTo: match.renc_id,
            }})
        // }
    }

    function Getday(tour)
    {
        if(championnat === "proad" || championnat === "probm")
        {
            if(tour === "16" || tour === "17") return "1/4";
            if(tour === "18" || tour === "19") return "1/2";
            if(tour === "20" || tour === "21") return "F";
        }
        if(championnat === "proam")
        {
            if(tour === "23" || tour === "24") return "1/2";
            if(tour === "25" || tour === "26") return "F";
        }

        return "J" + tour;
    }

    const clickable = championnatsValides.includes(championnat);
    const [scoreA, scoreB] = match.score.split('-').map((s) => parseInt(s.trim()) || 0);
    const libelleStatut = {bientot: "À venir", en_cours: "En direct", termine: "Terminé"}[match.status];

    return (
        <div className={"box_livescoring_component " + (championnat || "no_champ") + " " + match.status + (clickable ? "" : " not_clickable")} onClick={(e)=>handleClick(e)}>
            {/* TITLE */}
            <div className="box_livescoring_title_container">
                <span className="box_livescoring_title">
                    {getLongNameChamp(championnat) || "Rencontre"} <span className="box_livescoring_heure">· {match.heure_debut}</span>
                </span>
                <div className="box_livescoring_actions">
                    {/* Vidéo YouTube : lecteur en modale, sans suivre le lien de la carte */}
                    <VideoButton video={video} className="box_livescoring_video" />
                    {
                        libelleStatut &&
                        <span className={"box_livescoring_statut " + match.status}>
                            {match.status === "en_cours" && <span className="record" aria-hidden="true"></span>}
                            {libelleStatut}
                        </span>
                    }
                </div>
            </div>
            {/* CONTENT */}
            <div className="box_livescoring_content">
                <div className="box_day_container">
                    {
                        Getday(match.tour)
                    }
                </div>
                <div className="box_team">
                    <div className={"box_team_line" + (match.status === "termine" && scoreA > scoreB ? " winner" : "")}>
                        <span className="box_span_team">{match.equa}</span>
                        <span className="box_span_score">{scoreA}</span>
                    </div>
                    <div className={"box_team_line" + (match.status === "termine" && scoreB > scoreA ? " winner" : "")}>
                        <span className="box_span_team">{match.equb}</span>
                        <span className="box_span_score">{scoreB}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BoxLivescoring;